import * as React from 'react'
import { makeStyles, Link, Grid } from '@material-ui/core';
import {Soporte} from './Soporte';
import { Software } from '@portal/arq-portal-descarga-software';
import { IconIncidencia, IconTelefono } from "./Iconos";


export const SoporteComponent = (props:any) => {

  const useStyles = makeStyles(theme => ({
    linea: {
      padding: theme.spacing(1)
    },
    mainContainer:{
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignContent: 'stretch',
      alignItems: 'flex-start', 
      padding: '2%',
    },
    enlaceContainer:{
      order: 1,
      flex: '1', 
      '& .MuiPaper-rounded' :{
          height:"auto !important",
          maxHeight: "auto !important",
      }
    },
    soporteContainer:{
      backgroundColor: '#fff',
      padding: '10px',
      float: 'left',
    },
    headerContainer:{
      borderBottom: '1px solid #919191'
    },
    cabeceraH2:{
      marginRight:'5px',
      marginLeft:'5px',
      fontFamily: "CO-Bold",
      color: "#606060",
      fontSize: "16px",
      paddingBottom: "12px",
      paddingTop: "6px",
      marginTop: "0px",
      marginBottom: "0px",
    },
    gcoSiWrapper:{
      margin: '1rem auto',
      padding: '10px',
    }, 
    gcoSiWrapperP:{
      lineHeight: '20px', 
      color: '#606060', 
      fontSize: '12px', 
      margin: '0 0 30px'
    }, 
    gcoSiContainer:{
      display: 'flex',
      backgroundColor: '#f4f4f4', 
      padding: "15px",
      float: 'left',
      width: 'calc(50% - 40px)',
      marginBottom: '20px',
      '@media screen and (max-width: 767px)': {
        width: '100%',
        boxSizing: 'border-box',
      }
    }, 
    gcoSiContainerIncidencias: {
      marginRight: '20px',
      '& .MuiLink-root':{
        color: '#fff',
        backgroundColor: '#606060',
        fontSize: '12px',
        padding: '8px 25px', 
        fontWeight: 'bold', 
        display: 'inline-block',
        textAlign: 'center',
        marginTop: '10px',
        textDecoration: 'none',
        letterSpacing: '0.5px',
        '&:hover': {
          backgroundColor: '#919191',
        },
        '&:focus': {
          backgroundColor: '#DC0028',
        },
        '&:active': {
          backgroundColor: '#DC0028',
        },
      },
    },
    gcoSiIcon:{
      display:'block',
    }, 
    gcoSiIconTelefono:{
      color: '#dc0028', 
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    gcoSiText:{
      display:'block',
      paddingLeft: '20px', 
    },
    gcoSiTextHeader:{
      display:'block',
      fontSize: '12px',
      color: '#606060', 
      paddingBottom: "4px",
    },
    gcoSiTextTel:{
      display:'block',
      fontWeight: 'bold', 
      fontSize: '24px',
      color: '#dc0028' ,
      paddingBottom: "4px",
      
    },
    gcoSiTextFooter:{
      display:'block',
      fontSize: '12px',
      color: '#606060',
    },
    descargasContainer:{
      marginTop: '25px'
    }
  }));


  const classes = useStyles(props);
  let desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
  // Incidencia => Desarollo: 3  ,Producción: 1
  // Peticion => Desarrollo : 4  ,Producción: 3 
  return(
    <div className = {classes.mainContainer}>
      <Grid container spacing={2} style={{ padding: "12px 0px" }}>
      <Grid item xs={12} md={8} lg={6}>   
        <div className = {classes.soporteContainer}>
          <div className={classes.headerContainer}>
            <h2 className = {classes.cabeceraH2}>Incidencias</h2>
          </div>
          <div className = {classes.gcoSiWrapper}>
            <p className = {classes.gcoSiWrapperP}>
            GCO dispone de un departamento de Soporte Informático, dedicado a la resolución de las incidencias
            derivadas de la instalación, configuración y uso de los programas y servicios informáticos del Grupo. Usted puede contactar
            con este servicio rellenando el formulario de aviso de Incidencias, o si lo prefiere, mediante el número de teléfono siguiente:
            </p>
            <div className = {classes.gcoSiContainer+ ' '+classes.gcoSiContainerIncidencias}>
              <div className= {classes.gcoSiIconTelefono}>
              <IconIncidencia style={{
              height: 83,
              width: 63, 
              color: "#dc0028", 
              marginTop: '-12px'
          }}></IconIncidencia>
              </div>
              <div className = {classes.gcoSiText}>
                <span className= {classes.gcoSiTextHeader}>Formulario de aviso de incidencias: </span>
                <Link
                target="_blank"
                rel="noopener" 
                href= {desarrollo ? "https://grupodaplicaciones.gco.global/FE/ARQ.AppInt.Incidencia.FE.PreRedireccion/":"https://grupoaplicaciones.gco.global/FE/ARQ.AppInt.Incidencia.FE.PreRedireccion/"}>
                Notificar incidencia
              </Link>
              </div>
            </div>
            <div className = {classes.gcoSiContainer}>
              <div className= {classes.gcoSiIconTelefono}>
              <IconTelefono style={{
              height: 50,
              width: 50, 
              color: "#dc0028"
          }}></IconTelefono>
              </div>
              <div className = {classes.gcoSiText}>
                <span className= {classes.gcoSiTextHeader}>Nuevo teléfono de soporte informático: </span>
                <span className= {classes.gcoSiTextTel}>93 000 39 93</span>
                <span className= {classes.gcoSiTextFooter}>Atendemos las incidencias las 24 horas los 365 días del año.</span>
              </div>
            </div>

          </div>
          <div className={classes.headerContainer}>
            <h2 className = {classes.cabeceraH2}>Peticiones</h2>
          </div>
          <div className = {classes.gcoSiWrapper}>
            <p className = {classes.gcoSiWrapperP}>
            En GCO, estamos comprometidos con la mejora continua. Por ello, si necesita solicitar publicaciones, gestión de permisos y/o buzones de correos electrónicos, 
            cambios en los programas o aplicaciones que brindan nuestros servicios informáticos, puede hacerlo rellenando el siguiente 
            formulario de aviso de peticiones:
            </p>
            <div className = {classes.gcoSiContainer+ ' '+classes.gcoSiContainerIncidencias}>
              <div className= {classes.gcoSiIconTelefono}>
              <IconIncidencia style={{
              height: 83,
              width: 63, 
              color: "#dc0028", 
              marginTop: '-12px'
          }}></IconIncidencia>
              </div>
              <div className = {classes.gcoSiText}>
                <span className= {classes.gcoSiTextHeader}>Formulario de aviso de peticiones: </span>
                <Link
                target="_blank"
                rel="noopener"
                href= {desarrollo ? "https://grupodaplicaciones.gco.global/FE/ARQ.AppInt.Incidencia.FE.Alta/?tiposolicitud=4":"https://grupoaplicaciones.gco.global/FE/ARQ.AppInt.Incidencia.FE.Alta/?tiposolicitud=3"}>
                Notificar petición
              </Link>
              </div>
            </div>

          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={4} lg={6}>
      <div className={classes.enlaceContainer}>
        <Soporte></Soporte>
        <div className={classes.descargasContainer}><Software /></div>
      </div>
      </Grid>
      </Grid>
    </div>
  )
}